import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserDto } from '@api/core';
import { requiresPasswordChange } from '@shared/store/features/current-user.feature';
import { SharedStore } from '@shared/store/shared.signal-store';
import { waitToResolveSignal } from '@shared/utils/waitToResolve';
import { MarketMakingPlatformsStore } from 'app/market-making/shared/market-making-platforms.store';
import { map, of, switchMap } from 'rxjs';

export const adminShellGuard: CanActivateFn = () => {
  const sharedStore = inject(SharedStore);
  const platformsStore = inject(MarketMakingPlatformsStore);
  const router = inject(Router);

  const cached = sharedStore.currentUser();
  if (!cached) {
    sharedStore.loadCurrentUser();
  }

  const user$ = cached
    ? of(cached)
    : waitToResolveSignal(sharedStore.currentUserLoaded).pipe(map(() => sharedStore.currentUser()));

  return user$.pipe(
    switchMap(user => {
      const redirect = resolve(user, router);
      return redirect === true ? platformsStore.platformsReady().pipe(map(() => true)) : of(redirect);
    }),
  );
};

function resolve(user: UserDto | undefined, router: Router): boolean | ReturnType<Router['createUrlTree']> {
  if (!user) {
    return false;
  }
  if (requiresPasswordChange(user)) {
    return router.createUrlTree(['/change-password']);
  }
  if (user.role === UserDto.RoleEnum.AdminCompliance) {
    return router.createUrlTree(['/compliance/client-report']);
  }
  return true;
}
